import { Postcards } from './Postcards';
import PostcardsPage from './PostcardsPage';

export { Postcards, PostcardsPage };
